module.exports = __webpack_public_path__ + "static/media/12.f79e49f6.png";